/* Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Grid, TextField, Typography, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import FilterGroupTable from './FilterGroupTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {
  saveFilterGroup,
  ResetStatus as resetStatus,
  ResetMessage as resetMessage,
} from '../../../../../redux/reducers/EnableFramework/FilterGroup';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import DialogBox from '../../../../../components/DialogBox';
import SearchFilter from './AddFilter';
import AddIcon from '@material-ui/icons/Add';
import FilterGroupSystemNotes from './FilterGroupSystemNotes';
import {makeStyles} from '@material-ui/core/styles';
import {ArrowBack} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
}));

const FieldGroupForm = ({setValue, setFilterGroupCode, filterGroupCode, isCopyRowData}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);

  const {filterGroupDataStatus, filterGroupData, isLoading, errorMsg, successMsg} = useSelector(
    ({filterGroup}) => filterGroup,
  );

  const schema = Yup.object().shape({
    code: Yup.string()
      .required('Filter group code is required')
      .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed'),
    description: Yup.string().required('Filter group description is required'),
  });
  const initialVal = {
    name: '',
    code: '',
    description: '',
  };
  const [expanded, setExpanded] = useState();
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const [searchData, setSearchData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [initialValues, setInitialValues] = useState(initialVal);
  const [deleteFilter, setDeleteFilter] = useState([]);

  const [apiFieldList, setApiFieldList] = useState([]);

  useEffect(() => {
    if (filterGroupData && filterGroupData?.filters) {
      const fields = filterGroupData?.filters.map((e) => e.id);
      setApiFieldList(fields);
    }
  }, [filterGroupData]);
  const [deletedFields, setDeletedFields] = useState([]);
  useEffect(() => {
    if (selectedRows?.length >= 0) {
      const array = selectedRows.length ? selectedRows.map((a) => a.id) : [];
      const newFields = apiFieldList.filter((item) => !array?.includes(item));
      setDeletedFields(newFields);
    }
  }, [selectedRows]);

  useEffect(() => {
    if (filterGroupDataStatus === 200) {
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
    }
  }, [filterGroupDataStatus]);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (Object.keys(filterGroupData).length > 0) {
      const newInitialValues = {
        name: filterGroupData?.filterGroupName,
        code: isCopyRowData ? '' : filterGroupData?.filterGroupCode,
        description: filterGroupData?.filterGroupDescription,
      };
      setInitialValues(newInitialValues);
      const filterTableData = filterGroupData.filters.map((data) => {
        return {description: data.description, id: data.id, name: data.name};
      });
      setSelectedRows(filterTableData);
    }
  }, [filterGroupData, isCopyRowData, reset]);
  const handleSubmit = (data, props) => {
    const passvalue = {
      deletedId: deletedFields,
      filterGroupCode: data?.code ? data.code.toUpperCase() : '',
      filterGroupDescription: data?.description ? data.description : '',
      filterGroupId: isCopyRowData ? 0 : filterGroupData.filterGroupId || 0,
      filterGroupName: data?.name ? data.name : '',
      filterId: [],
    };
    selectedRows.forEach((item) => {
      passvalue.filterId.push(item.id);
    });
    dispatch(saveFilterGroup(passvalue));
  };

  return (
    <div>
      <div className={`mb-0`}>
        <div className="button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
           Search Filter Group
          </Button>
        </div>
        <Formik
          onSubmit={(values, {validate}, props) => {
            handleSubmit(values, props);
            validate(values);
          }}
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              touched,
              resetForm,
              errors,
            } = props;
            return (
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <ErrorBoundaryForComponents>
                    <Grid className="form-row global-field-textfields" container spacing={2}>
                      <Grid item sm={6} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Filter Group Code`}
                          label="Filter Group Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="code"
                          value={values?.code?.toUpperCase()}
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={errors.code && touched.code}
                        />
                        <FormHelperText>
                          {touched.code && errors.code}
                        </FormHelperText>
                      </Grid>
                      <Grid item sm={6} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Filter Group Name"
                          label="Filter Group Name"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item sm={6} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Filter Group Description`}
                          label="Filter Group Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.description}
                          error={errors.description && touched.description}
                        />
                        <FormHelperText>
                          {touched.description && errors.description}
                        </FormHelperText>
                      </Grid>
                    </Grid>
                  </ErrorBoundaryForComponents>
                </div>
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot}`}
                    onClick={() => setOpen(true)}
                  >
                    <AddIcon />
                    Add Filter
                  </Button>
                </div>
                <FilterGroupTable
                  setSelectedRows={setSelectedRows}
                  selectedRows={selectedRows}
                  deleteFilter={deleteFilter}
                  setDeleteFilter={setDeleteFilter}
                />
                <div className="button-spacing-mb">
                  <Button
                    type="button"
                    variant="outlined"
                    className={`reset-btn  mx-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      if (!filterGroupCode) {
                        resetForm();
                        setSelectedRows([]);
                      } else {
                        setInitialValues({});
                        resetForm();
                        setReset(!reset);
                      }
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    type="submit"
                    variant="outlined"
                    className={`search-btn mx-1  ${classes.buttonRoot}`}
                    color="primary"
                    disabled={!(selectedRows.length > 0)}
                  >
                    Save
                  </Button>
                </div>

                <DialogBox open={open} dialogClose={handleClose} title="Add Filter" maxWidth="lg">
                  <SearchFilter
                    setValue={setValue}
                    handleClose={handleClose}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    setSearchData={setSearchData}
                    searchData={searchData}
                  />
                </DialogBox>
                {isLoading && <PageLoader />}
                {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
                {successMsg && <SuccessSnackbar successMsg={successMsg} />}
              </form>
            );
          }}
        </Formik>
        {filterGroupData?.filterGroupName && !isCopyRowData && (
          <div className={`${classes1.root} mt-3`}>
            <Accordion
              className="accordion-styling"
              expanded={expanded === 'panel1'}
              onChange={handleAccordionChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>Filter Group Notes</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <FilterGroupSystemNotes
                  setFilterGroupCode={setFilterGroupCode}
                  filterGroupCode={filterGroupCode}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldGroupForm;
